// Cache leve em localStorage dos últimos pagamentos vistos — usado pelo
// /embed pra nunca aparecer quebrado: se o nó estiver offline, ele ainda
// consegue plotar um grafo estático com os dados mais recentes conhecidos.
const KEY = 'simc-observer-cache-v1';
const MAX_PAYMENTS = 300;

export function saveSnapshot(payments) {
  try {
    const trimmed = payments.slice(-MAX_PAYMENTS).map((p) => ({ ...p, value: p.value.toString() }));
    localStorage.setItem(KEY, JSON.stringify({ savedAt: Date.now(), payments: trimmed }));
  } catch {
    // localStorage indisponível (modo privado, iframe sandboxed sem storage, etc.) — sem cache, sem drama.
  }
}

export function loadSnapshot() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.payments?.length) return null;
    return {
      savedAt: parsed.savedAt,
      payments: parsed.payments.map((p) => ({ ...p, value: BigInt(p.value) })),
    };
  } catch {
    return null;
  }
}
